import { ChallengeFormType, FormValidator } from '../../NewChallengeForm.types';

type Params = Pick<ChallengeFormType, 'price'>;

export const validate: FormValidator<Params> = () => {
  return { isValid: true };
};
